/* eslint-env browser */
import newPricingPlan from './new-pricing';

const pages = [newPricingPlan];

export default function register() {
  pages.forEach(page => page());
}



// WEBPACK FOOTER //
// ./src/pages/ab-variants/client.js